import { Skeleton } from '@mint-lib/tw-components';

const RecipientsCommentsTabSkeleton = () => {
  return (
    <div aria-label="Recipients and Comments tab is loading">
      <Skeleton className="h-4 w-20" />
      <Skeleton className="mt-1 h-10 w-full" />
      <Skeleton className="mt-4 h-4 w-25" />
      <Skeleton className="mt-1 min-h-32 w-full" />
    </div>
  );
};

export default RecipientsCommentsTabSkeleton;
